import { render, staticRenderFns } from "./ReviewModifyExpirationDate.vue?vue&type=template&id=935dda06&scoped=true"
import script from "./ReviewModifyExpirationDate.vue?vue&type=script&lang=js"
export * from "./ReviewModifyExpirationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935dda06",
  null
  
)

export default component.exports